import React, { useRef, useState } from "react";
import { Modal, Radio } from "antd";
import { useMutation } from '@tanstack/react-query';
import TalentCandidate from "../../../models/TalentCandidate";
import { useOpportunity } from "../../../providers/OpportunityProvider";
import LoadingSpinner from "../../../components/LoadingSpinner";
import SpinLoader from "../../../components/SpinLoader";
import AIIcon from "../../../components/AiIcon";

const promptLengthOptions = [
    {
        label: 'Longer',
        value: 'longer',
    },
    {
        label: 'Shorter',
        value: 'shorter',
    },
    {
        label: 'No change',
        value: 'none',
    }
]
const promptFormalityOptions = [
    {
        label: 'More Formal',
        value: 'formal',
    },
    {
        label: 'Less Formal',
        value: 'informal',
    },
    {
        label: 'No change',
        value: 'none',
    }
]

const getPromptFromOptions = (lengthOption, formalityOption) => {

    console.log('getPromptFromOptions', `${lengthOption}-${formalityOption}`)
    switch (`${lengthOption}-${formalityOption}`) {
        case 'longer-formal':
            return 'Make the length slightly longer and make the tone more formal'
        case 'shorter-formal':
            return 'Make the length shorter and make the tone more formal'
        case 'none-formal':
            return 'Make the tone more formal'

        case 'longer-informal':
            return 'Make the length slightly longer and make the tone less formal'
        case 'shorter-informal':
            return 'Make the length shorter and make the tone less formal'
        case 'none-informal':
            return 'Make the tone less formal'
        case 'longer-none':
            return 'Make the length slightly longer'
        case 'shorter-none':
            return 'Make the length shorter'
        case 'none-none':
            return 'Generate again'

    }
}
const CoverLetterChatGPTModal = ({ onSubmit, isDisabled, onUpdate, proposalsGenerated = 0, onFetch, requestParams = {} }) => {
    const { opportunity } = useOpportunity();
    const coverletterBtnRef = useRef(null);

    const [selectedCoverLetter, setSelectedCoverLetter] = useState(null);
    const [selectedRelevantExperience, setSelectedRelevantExperience] = useState(null);
    const [generatedResponse, setGeneratedResponse] = useState({})

    const [isAdjusting, setIsAdjusting] = useState(false)
    const [promptOptions, setPromptOptions] = useState({ length: undefined, formality: undefined })

    const [isChatGPTModalOpen, setIsChatGPTModalOpen] = useState(false);

    const onClose = async () => {
        await setSelectedCoverLetter(null)
        return setIsChatGPTModalOpen(false)
    }

    const chatGPTCoverLetterMutation = useMutation(['coverLetterChatGPT'], async () => {
        await TB.wait(2000)
        return TalentCandidate.coverLetterChatGPT(opportunity.project_position.id, requestParams)
    }, {
        onSuccess: async res => {
            await onUpdate();
            await setGeneratedResponse(res);
            // setSelectedCoverLetter(res.proposal.cover_letter);
            // setSelectedRelevantExperience(res.proposal.relevant_experience);

        },
        onError: err => {
            console.log(err, 'ERROR!!')
        }
    })
    const chatGPTCoverLetterAdjustMutation = useMutation(['coverLetterChatGPTAdjust'], async (options) => {
        await TB.wait(2000)
        console.log('prompt', options)
        let prompt = getPromptFromOptions(options.length, options.formality)
        return TalentCandidate.coverLetterChatGPTAdjust(opportunity.project_position.id, generatedResponse.conversation, prompt)
    }, {
        onSuccess: async (res) => {
            await onUpdate();
            await setGeneratedResponse(res);
            setIsAdjusting(false)
            // setSelectedCoverLetter(res.proposal.cover_letter);
            // setSelectedRelevantExperience(res.proposal.relevant_experience);

        },
        onError: err => {
            console.log(err, 'ERROR!!')
            setIsAdjusting(false)
        }
    })

    const isMutationsLoading = chatGPTCoverLetterMutation?.isLoading || chatGPTCoverLetterAdjustMutation?.isLoading
    if (!opportunity.isProposingAsIndividual()) {
        return null;
    }


    return (
        <>
            <div className="flex flex-col items-start" ref={coverletterBtnRef}>
                <button
                    disabled={isDisabled || !opportunity?.canGenerateCoverLetter()}
                    type="button"
                    onClick={() => setIsChatGPTModalOpen(true)}
                    aria-label="Chat GPT Cover Letter"
                    className={TB.mapClass(
                        "flex flex-row items-center gap-0.5 pr-3.5 pl-2.5 py-1 rounded-xl",
                        {
                            "bg-blue-500 text-white": opportunity?.canGenerateCoverLetter(),
                            "bg-slate-200 text-gray opacity-80": !opportunity?.canGenerateCoverLetter()
                        }
                    )}>
                    <AIIcon size={22} fill={opportunity.canGenerateCoverLetter() ? '#ffffff' : TB.config('color.disabled')} />
                    <span className="flex flex-col gap-0.5">
                        <span className="text-xs whitespace-no-wrap">
                            Generate Cover Letter
                        </span>
                        <span className="text-xxs italic whitespace-no-wrap">
                            {TB.pluralize('attempt', 3 - proposalsGenerated, true)} remaining
                        </span>
                    </span>
                </button>
            </div>


            <Modal
                onCancel={onClose}
                closable
                maskClosable={!isDisabled && !isMutationsLoading.isLoading}
                footer={false}
                destroyOnClose={true}
                width={(generatedResponse?.proposal && !isAdjusting) ? '80%' : 650}
                title={false}
                open={isChatGPTModalOpen}
                zIndex={101}
                getContainer={coverletterBtnRef ? () => coverletterBtnRef?.current : undefined}>

                <SpinLoader className="relative" isLoading={isMutationsLoading}>
                    {/* <div className="absolute top-[-10px] py-0.5 px-0.5" style={{ right: 15 }}>
                        <span className={TB.mapClass("text-xxs font-semibold text-danger", {
                            // "text-black": proposalsGenerated < 3,
                            "text-danger": proposalsGenerated >= 3,
                        })}>
                            {TB.pluralize('attempt', 3 - proposalsGenerated, true)} remaining
                        </span>
                    </div> */}
                    <div className="min-h-[200px] flex flex-col items-stretch justify-between relative">

                        {isAdjusting ? (
                            <div className="flex flex-col gap-2 items-stretch">
                                <div className="flex justify-between w-[96%]">
                                    <p className="text-base text-left font-medium mb-4">
                                        Adjust My Generated Cover Letter
                                    </p>
                                    <p className={TB.mapClass("text-xxs font-semibold text-danger", {
                                        // "text-black": proposalsGenerated < 3,
                                        "text-danger": proposalsGenerated >= 3,
                                    })}>
                                        {TB.pluralize('attempt', 3 - proposalsGenerated, true)} remaining
                                    </p>
                                </div>
                                <div className="flex flex-col text-center  pt-2">
                                    <p className="text-left">
                                        Choose options below to make adjustments to your generated
                                        intro and relevant experience
                                    </p>
                                </div>

                                <div className="flex flex-col gap-1 items-center mt-4 mb-3">
                                    <p className="font-semibold my-3 text-center">
                                        Length
                                    </p>
                                    <div className="self-center">
                                        <Radio.Group options={promptLengthOptions} onChange={e => {
                                            setPromptOptions({ ...promptOptions, length: e.target.value })
                                        }} value={promptOptions.length}
                                            buttonStyle="solid" optionType="button" />
                                    </div>
                                </div>
                                <div className="flex flex-col gap-1 items-center mb-8">

                                    <p className="font-semibold my-3 text-center">
                                        Formality
                                    </p>
                                    <div className="self-center">
                                        <Radio.Group options={promptFormalityOptions} onChange={e => {
                                            setPromptOptions({ ...promptOptions, formality: e.target.value })
                                        }} value={promptOptions.formality} buttonStyle="solid" optionType="button" />
                                    </div>
                                </div>

                            </div>
                        ) : (
                            generatedResponse?.proposal ? (
                                <div className="text-center">
                                    <div className="flex justify-between w-[96%]">
                                        <p className="mb-4 text-base font-medium text-left">
                                            Your Generated Cover Letter
                                        </p>
                                        <p className={TB.mapClass("text-xxs font-semibold text-danger", {
                                            // "text-black": proposalsGenerated < 3,
                                            "text-danger": proposalsGenerated >= 3,
                                        })}>
                                            {TB.pluralize('attempt', 3 - proposalsGenerated, true)} remaining
                                        </p>
                                    </div>
                                    <div className="flex flex-col gap-4 text-left pt-2">
                                        <p>
                                            {/* Based on your profile and resume, we've generated a cover letter that fits
                                            this role. Select “Continue” to use this as a template. After, you will be
                                            able to make changes or restart at any time. */}

                                            Based on your profile and resume, we've utilized AI to generate a cover
                                            letter for this position. Select "Accept and Continue" below to use this as a
                                            template (you will be able to make changes). You can also try again below.
                                        </p>
                                        <p className="text-xs text-danger">
                                            <span className="font-bold">
                                                NOTE:
                                            </span>
                                            &nbsp;
                                            Your current cover letter (both intro and relevant experience) will be
                                            replaced.
                                        </p>

                                        <div className="w-full flex flex-col md:flex-row gap-6 mt-4 mb-8">
                                            <div className="relative flex-1 text-left">
                                                <p className="text-xl mb-1.5 text-bold">Cover Letter:</p>
                                                <div className="bg-gray-50 border rounded-sm p-2">
                                                    <div className="rich-text-display">
                                                        <span
                                                            dangerouslySetInnerHTML={{ __html: generatedResponse?.proposal.cover_letter }} />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="relative flex-1 text-left">
                                                <p className="text-xl mb-1.5 text-bold">Relevant Experience:</p>
                                                <div className="bg-gray-50 border rounded-sm p-2">
                                                    <div className="rich-text-display">
                                                        <span
                                                            dangerouslySetInnerHTML={{ __html: generatedResponse?.proposal.relevant_experience }} />
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            ) : (
                                <div className="flex flex-col flex-1 text-center">
                                    <div className="flex justify-between flex-wrap w-[96%]">
                                        <p className="mb-2 text-base font-medium text-left">
                                            {/* Generate My Cover Letter */}
                                            Your AI Cover Letter
                                        </p>
                                        <p className={TB.mapClass("text-xxs mb-4 font-semibold text-danger", {
                                            // "text-black": proposalsGenerated < 3,
                                            "text-danger": proposalsGenerated >= 3,
                                        })}>
                                            {TB.pluralize('attempt', 3 - proposalsGenerated, true)} remaining
                                        </p>
                                    </div>

                                    <div className="text-sm text-left pt-2">
                                        <p>
                                            Use our enhanced AI technology to help compose your cover letter.
                                            We'll utilize your profile and resume to generate a unique cover letter
                                            tailored just for this role.
                                        </p>


                                    </div>
                                    <p className="text-xs text-danger self-start text-left my-6">
                                        <span className="font-bold">
                                            NOTE:
                                        </span>
                                        &nbsp;
                                        Your current cover letter (both intro and relevant experience) will be replaced.
                                    </p>
                                    <div className="flex flex-col gap-3 mb-8 text-sm text-left">
                                        <p>
                                            Once generated, we will show you a preview for your cover letter.
                                            &nbsp;
                                            {proposalsGenerated < 2 ?
                                                'You can then make adjustments to length and tone, or regenerate another version from scratch.'
                                                : ''
                                            }
                                        </p>
                                        {/*<p className="text-secondary my-3 font-medium">*/}
                                        {/*    You will get 3 attempts for this proposal.*/}
                                        {/*</p>*/}
                                        <p className="text-lg font-semibold mt-3 text-center">
                                            Ready to get started?
                                        </p>
                                        <p className="text-xs text-gray-500 text-center">This make take a few seconds</p>

                                    </div>

                                    {isMutationsLoading.isLoading && (
                                        <div className="text-sm flex-1 flex items-center justify-center">
                                            <LoadingSpinner size='lg' />
                                        </div>
                                    )}
                                </div>
                            )
                        )}


                        <div className="mt-4 flex flex-row justify-end">
                            <button
                                className="btn btn-outline-dark text-xs"
                                type="button"
                                onClick={async () => {
                                    if (isAdjusting) {
                                        await setIsAdjusting(false)
                                        return setPromptOptions({ length: undefined, formality: undefined })
                                    }
                                    return onClose()
                                }}
                                disabled={isDisabled || isMutationsLoading.isLoading}
                            >
                                {isAdjusting ? "Go Back" : "Cancel"}
                            </button>

                            {isAdjusting ? (
                                <button
                                    type="button"
                                    onClick={() => chatGPTCoverLetterAdjustMutation.mutateAsync(promptOptions)}
                                    className="btn btn-primary ml-3 text-xs"
                                    disabled={isDisabled || !promptOptions?.length || !promptOptions.formality || isMutationsLoading.isLoading}
                                >
                                    Submit
                                </button>
                            ) : (!!generatedResponse?.proposal?.cover_letter ? (
                                <React.Fragment>
                                    <button
                                        type="button"
                                        onClick={async () => {
                                            await onSubmit({
                                                cover_letter: generatedResponse?.proposal?.cover_letter,
                                                selected_cover_letter: TB.uuid(),
                                                relevant_experience: generatedResponse?.proposal?.relevant_experience,
                                                selected_relevant_experience: TB.uuid(),
                                            })
                                            return onClose();
                                        }}
                                        className="btn btn-primary ml-3 text-xs"
                                        disabled={isDisabled || !generatedResponse?.proposal?.cover_letter}
                                    >
                                        Accept and continue
                                    </button>
                                    {proposalsGenerated < 3 && (
                                        <button
                                            type="button"
                                            onClick={() => {
                                                if (proposalsGenerated >= 3) {
                                                    return TB.toast("Max attempts reached for this proposal", { theme: 'danger' })
                                                }
                                                return setIsAdjusting(true)
                                            }}
                                            className="btn btn-dark ml-3 text-xs"
                                            disabled={isDisabled || isMutationsLoading.isLoading}
                                        >
                                            {/* Make Adjustments */}
                                            Try Again
                                        </button>
                                    )}

                                </React.Fragment>
                            ) : (
                                <button
                                    type="button"
                                    onClick={() => {
                                        if (proposalsGenerated >= 3) {
                                            return TB.toast("Max attempts reached for this proposal", { theme: 'danger' })
                                        }
                                        return chatGPTCoverLetterMutation.mutateAsync()
                                    }}
                                    className="btn btn-primary ml-3 text-xs"
                                    disabled={isDisabled || isMutationsLoading.isLoading}
                                >
                                    Yes, Continue
                                </button>
                            ))}

                        </div>
                    </div>

                </SpinLoader>
            </Modal>
        </>
    )
}

export default CoverLetterChatGPTModal;